import axios from "axios"

const state = {
    loadedItems: {
        images: false,
        fonts: false,
        mainPage: false,
        collections: false,
        prevRouteExists: false,
    },
    footer: {},
    themeSettings: {},
    fontSettings: {}
}

const actions = {
    async fetchMainPage({ commit }) {
        //SET DEFAULT DATA IN CASE SERVER DOWN?

        //Data that is loaded while loading spinner
        const homeResponse = await axios.get(process.env.VUE_APP_BASE_URL + '/wp-json/acf/v3/presentation/171');
        //window.console.log(homeResponse)

        commit('setMainPage', homeResponse ? homeResponse.data : 'error');
        commit('setLoadedItem', {
            loadedProperty: 'mainPage',
            isLoaded: true
        });
    },
    async fetchPresentation({ commit }, presentationId) {
        //SET DEFAULT DATA IN CASE SERVER DOWN?

        //Data that is loaded while loading spinner
        let homeResponse = await axios.get(process.env.VUE_APP_BASE_URL + '/wp-json/acf/v3/presentation/' + presentationId);
        if (!homeResponse || !homeResponse.data || (homeResponse && homeResponse.data && (!homeResponse.data.acf.landing_video || !homeResponse.data.acf.collection_items))) {
            homeResponse = await axios.get(process.env.VUE_APP_BASE_URL + '/wp-json/acf/v3/presentation/171');
        } else {
            if (homeResponse && homeResponse.data) {
                homeResponse.data.acf.presentationId = presentationId;
            }
        }
        commit('setMainPage', homeResponse ? homeResponse.data : 'error');
        commit('setLoadedItem', {
            loadedProperty: 'mainPage',
            isLoaded: true
        });
    },
    async fetchCollections({ commit }) {
        //SET DEFAULT DATA IN CASE SERVER DOWN?

        //Data that is loaded while loading spinner
        const collectionsResponse = await axios.get(process.env.VUE_APP_BASE_URL + '/wp-json/acf/v3/collection?per_page=100', {
            slug: 'collection'
        });
        if (!collectionsResponse.data) return;
        let hiddenFilteredOut = collectionsResponse.data.filter((collection) => {
            return collection.acf.hide != true;
        });
        let preloadImageUrls = hiddenFilteredOut.map((collection) => {
            return collection.acf.video_thumbnail.url;
        });
        preloadImageUrls = preloadImageUrls.filter((url) => url != null);
        preloadImages(
            preloadImageUrls,
            function () {
                commit('setLoadedItem', {
                    loadedProperty: "images",
                    isLoaded: true
                });
            }
        );
        commit('setCollections', hiddenFilteredOut ? hiddenFilteredOut : 'error');
        commit('setLoadedItem', {
            loadedProperty: 'collections',
            isLoaded: true
        });
    },
    async fetchFooter({ commit }) {
        const response = await axios.get(process.env.VUE_APP_BASE_URL + '/wp-json/acf/v3/footer/302');

        commit('setFooter', response ? response.data : 'error');
    },
    async fetchColors({ commit }) {
        const response = await axios.get(process.env.VUE_APP_BASE_URL + '/wp-json/acf/v3/theme_settings/323');
        commit('setThemeSettings', response ? response.data : 'error');
    },
    async fetchFontSettings({ commit }) {
        const response = await axios.get(process.env.VUE_APP_BASE_URL + '/wp-json/acf/v3/font_settings/345');
        commit('setFontSettings', response ? response.data : 'error');
    },
    async setLoadedItem({ commit }, payload) {
        commit('setLoadedItem', payload)
    },
    async setPrevRouteExists({ commit }, payload) {
        commit('setPrevRouteExists', payload)
    }
}

const mutations = {
    setMainPage: (state, payload) => {
        if (!payload.acf) return;
        let mainPageData = payload.acf;
        let grid_layout = [];
        let collection_ids = [];
        mainPageData.collection_items.forEach((collection) => {
            grid_layout.push(collection.acf_fc_layout);
            if (collection['collection_item']) {
                collection_ids.push(collection['collection_item']);
            }
            if (collection['collection_item_2']) {
                collection_ids.push(collection['collection_item_2']);
            }
            if (collection['collection_item_3']) {
                collection_ids.push(collection['collection_item_3']);
            }
        });

        if (grid_layout.length > 0) {
            mainPageData.grid_layout = grid_layout;
        }
        mainPageData.collection_ids = collection_ids;

        state.mainPage = mainPageData;
    },
    setCollections: (state, payload) => {
        if (!payload) return;

        state.collections = payload;



    },
    setLoadedItem: (state, payload) => {
        state.loadedItems = {
            ...state.loadedItems,
            [payload.loadedProperty]: payload.isLoaded
        }
    },
    setPrevRouteExists: (state, payload) => {
        state.prevRouteExists = payload;
    },
    setFooter: (state, payload) => {
        if (!payload) return;
        state.footer = payload['acf'];

    },
    setThemeSettings: (state, payload) => {
        if (!payload) return;
        state.themeSettings = payload['acf'];

    },
    setFontSettings: (state, payload) => {
        if (!payload) return;
        state.fontSettings = payload['acf'];

    },
}

const getters = {
    themeSettings: state => state.themeSettings,
    fontSettings: state => state.fontSettings
  };

function preloadImages(urlArray, allImagesLoadedCallback) {
    let that = this;
    let loadedCounter = 0;
    urlArray.forEach(url => {
        preloadImage(url, function () {
            loadedCounter++;
            if (loadedCounter === urlArray.length) {
                allImagesLoadedCallback();
            }
        });
    });
    function preloadImage(url, imageLoadedCallback) {
        let img = new Image();
        img.onload = imageLoadedCallback;
        img.src = url;
    }
}


export default {
    state,
    actions,
    mutations,
    getters
}